var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from './base-management-service';
var VendorService = /** @class */ (function (_super) {
    __extends(VendorService, _super);
    function VendorService() {
        return _super.call(this, '/api/v1/management/vendor') || this;
    }
    VendorService.prototype.doesVendorIdExist = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var url, request, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'doesvendoridexist';
                        request = { Id: item.vendorId };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error('Unable to check if vendor id is a duplicate');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Unable to check if vendor id is a duplicate');
                        console.error(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getAllRef = function (url) {
        if (url === void 0) { url = 'getallref'; }
        return __awaiter(this, void 0, Promise, function () {
            var response, responseMessage, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.get.call(this, url)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get vendors');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Unable to get vendors");
                        console.error(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getRefBySiteMatGroup = function (siteId, materialGroupId) {
        if (materialGroupId === void 0) { materialGroupId = 'D'; }
        return __awaiter(this, void 0, Promise, function () {
            var url, response, responseMessage, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'getrefbysitematgroup';
                        return [4 /*yield*/, _super.prototype.post.call(this, url, { SiteId: siteId, MaterialGroupId: materialGroupId })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get vendors');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error("Unable to get vendors");
                        console.error(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getRefBySiteIdMaterialId = function (siteId, materialId) {
        return __awaiter(this, void 0, Promise, function () {
            var url, response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'getrefbysiteidmaterialid';
                        return [4 /*yield*/, _super.prototype.post.call(this, url, { SiteId: siteId, MaterialId: materialId })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get vendors');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error("Unable to get vendors");
                        console.error(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getRefBySiteMatTypeForContract = function (siteId, materialTypeId) {
        if (materialTypeId === void 0) { materialTypeId = 'D'; }
        return __awaiter(this, void 0, Promise, function () {
            var url, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'getcontractsources';
                        return [4 /*yield*/, _super.prototype.post.call(this, url, { SiteId: siteId, MaterialTypeId: materialTypeId })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get vendors');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error("Unable to get vendors");
                        console.error(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getRefBySiteIdMaterialIdForContract = function (siteId, materialId) {
        return __awaiter(this, void 0, Promise, function () {
            var url, response, responseMessage, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'getcontractsourcesbymaterialid';
                        return [4 /*yield*/, _super.prototype.post.call(this, url, { SiteId: siteId, MaterialId: materialId })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get vendors');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        console.error("Unable to get vendors");
                        console.error(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get list of available vendors based on params
     * @param siteId Site Id, e.g. '0001'
     * @param sourceType Source Type, e.g. 'Contract'
     * @param materialId Material Id, e.g. '0096'
     * @param materialTypeId Material Group Id, e.g. 'D'
     * @example getRefBySiteIdSourceTypeMaterialId('0003', 'CONTRACT', '0096')
     */
    VendorService.prototype.getRefBySiteIdSourceTypeMaterialId = function (siteId, sourceType, materialId, materialTypeId) {
        if (materialTypeId === void 0) { materialTypeId = 'D'; }
        return __awaiter(this, void 0, void 0, function () {
            var availableVendors, contractVendors, dieselVendors;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        availableVendors = [];
                        // if no site Id then return early
                        if (!siteId) {
                            return [2 /*return*/, availableVendors];
                        }
                        if (!(sourceType === this.contractSourceType)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.getRefBySiteMatTypeForContract(siteId, materialTypeId)];
                    case 1:
                        contractVendors = (_a.sent()).data;
                        if (!(materialId && materialId.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getRefBySiteIdMaterialIdForContract(siteId, materialId)];
                    case 2:
                        // get all vendors that provide the selected material and are contract vendors
                        availableVendors = (_a.sent()).data;
                        return [3 /*break*/, 4];
                    case 3:
                        availableVendors = contractVendors;
                        _a.label = 4;
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        if (!(sourceType === this.manualSourceType)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.getRefBySiteMatGroup(siteId, materialTypeId)];
                    case 6:
                        dieselVendors = (_a.sent()).data;
                        if (!(materialId && materialId.length > 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getRefBySiteIdMaterialId(siteId, materialId)];
                    case 7:
                        // get all vendors that provide the selected material
                        availableVendors = (_a.sent()).data;
                        return [3 /*break*/, 9];
                    case 8:
                        availableVendors = dieselVendors;
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        availableVendors = [];
                        _a.label = 11;
                    case 11: return [2 /*return*/, availableVendors];
                }
            });
        });
    };
    VendorService.prototype.canDeleteVendor = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var url, request, response, responseMessage, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = 'candelete';
                        request = { Id: item.vendorId };
                        return [4 /*yield*/, _super.prototype.post.call(this, url, request)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, responseMessage.data];
                        }
                        else {
                            throw new Error('Unable to check if vendor can be deleted');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        console.error('Unable to check if vendor can be deleted');
                        console.error(error_7);
                        throw error_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getSiteAssociationsByVendorId = function (vendorId) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'siteassociation/getbyvendorid';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Id: vendorId })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error("Unable to get site associations");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_8 = _a.sent();
                        console.error("Unable to get site associations");
                        console.error(error_8);
                        throw error_8;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.saveSiteAssociation = function (siteAssociation, mode) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, data, response, error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = "siteassociation/" + mode;
                        data = __assign({}, siteAssociation);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {
                                VendorId: data.vendorId,
                                SiteId: data.siteId,
                                MaterialGroupId: data.materialGroupId,
                                Direction: data.direction,
                                Miles: data.miles,
                                DestinationLoadNumber: data.destinationLoadNumber,
                                EbolShipTo: data.ebolShipTo,
                                Status: data.status,
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error("Unable to " + mode + " site association");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_9 = _a.sent();
                        console.error("Unable to " + mode + " site association");
                        console.error(error_9);
                        throw error_9;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.generateExcelReport = function () {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, error_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'generatereport';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, {}, {
                                responseType: 'arraybuffer',
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_10 = _a.sent();
                        console.error("Unable to generate report");
                        console.error(error_10);
                        throw error_10;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.updateVendorNames = function (column, oldValue, newValue) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, request, response, error_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = 'updatevendornames';
                        request = {
                            ColumnUpdated: column,
                            OldValue: oldValue,
                            NewValue: newValue,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, request, {
                                responseType: 'arraybuffer',
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            throw new Error(response.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_11 = _a.sent();
                        console.error("Unable to update vendor names");
                        console.error(error_11);
                        throw error_11;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    VendorService.prototype.getDefault = function () {
        return {
            vendorId: '',
            vendorName: '',
            supplierId: '',
            supplierName: '',
            vendorType: '',
            vendorSubType: '',
            abbreviatedSupplier: '',
            exchange: '',
            abbreviatedCity: '',
            abbreviatedTerminal: '',
            brandedType: '',
            terminalNumber: '',
            terminalName: '',
            terminalAlias: '',
            terminalAddressStreet: '',
            terminalAddressCity: '',
            terminalAddressState: '',
            terminalAddressZip: '',
            priceExpirationTime: '',
            unitOfMeasure: '',
            ebolTiming: '',
            vendorBillTime: '',
            allocationTime: '',
            timeZoneOffset: '',
            timeZoneAbbreviation: '',
            daylightSavingsObserved: false,
            carrierLoadNumber: '',
            carrierLoadInstructions: '',
            bioPercentageMax: 0,
            notes: '',
            isDeleted: false,
            createdId: '',
            createdDate: '',
            modId: '',
            modDate: '',
            siteAssociations: [],
            vendorBolFormats: [],
        };
    };
    VendorService.prototype.getDefaultSiteAssociation = function () {
        return {
            vendorId: '',
            siteId: '',
            siteName: '',
            market: '',
            materialGroupId: '',
            materialGroupName: '',
            direction: '',
            miles: '',
            destinationLoadNumber: '',
            ebolShipTo: '',
            status: '',
            createdId: '',
            createdDate: '',
            modId: '',
            modDate: '',
        };
    };
    VendorService.prototype.getDefaultBolFormat = function () {
        return {
            vendorBolFormatId: '',
            bolFormat: '',
            createdId: '',
            createdDate: '',
        };
    };
    VendorService.prototype.getValidationRules = function () {
        return {
            vendorId: { required: true, max: 4, alpha_num: true, isUniqueVendorId: true },
            vendorName: { required: true, max: 35 },
            supplierId: { required: true, max: 6 },
            supplierName: { required: true, max: 35 },
            vendorType: { required: true },
            vendorSubType: { required: true },
            abbreviatedSupplier: { required: true, max: 10 },
            exchange: { max: 3 },
            abbreviatedCity: { required: true, max: 10 },
            abbreviatedTerminal: { required: true, max: 3 },
            brandedType: { required: true, max: 2 },
            terminalNumber: { required: true, max: 15 },
            terminalName: { required: true, max: 200 },
            terminalAlias: { max: 30 },
            terminalAddressStreet: { required: true, max: 50 },
            terminalAddressCity: { required: true, max: 30 },
            terminalAddressState: { required: true, max: 2 },
            terminalAddressZip: { required: true, max: 10 },
            priceExpirationTime: { required: true },
            unitOfMeasure: { required: true },
            ebolTiming: { required: true },
            vendorBillTime: { required: true },
            allocationTime: { required: true },
            timeZoneAbbreviation: { required: true },
            carrierLoadNumber: { max: 50 },
            carrierLoadInstructions: { max: 500 },
            notes: { max: 500 },
        };
    };
    VendorService.prototype.getSiteAssociationValidationRules = function () {
        return {
            siteId: { required: true },
            materialGroupId: { required: true },
            direction: { max: 10 },
            miles: { max: 4, numeric: true },
            destinationLoadNumber: { max: 500 },
            ebolShipTo: { max: 500 },
            status: { required: true, max: 1 },
        };
    };
    VendorService.prototype.getBioPercentageByBoolean = function (val) {
        return val ? 0.05 : 0;
    };
    VendorService.prototype.getUpToFivePercentBioFlagByValue = function (val) {
        return val === 0.05;
    };
    Object.defineProperty(VendorService.prototype, "canCreateVendors", {
        get: function () {
            return this.authService.isAuthorized('VENDORMGMT_WRITE_DETAILS');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canDeleteVendors", {
        get: function () {
            return this.authService.isAuthorized('VENDORMGMT_WRITE_DETAILS');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canEditVendor", {
        get: function () {
            return this.canEditPage('VENDORMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canEditVendorDetails", {
        // SRS 23-2582: restrict who can edit the "details" page of an existing vendor.
        get: function () {
            return this.authService.isAuthorized('VENDORMGMT_WRITE_DETAILS');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canExportVendors", {
        get: function () {
            return this.canViewSection('VENDORMGMT', 'EXCELEXPORT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canViewSuppliers", {
        get: function () {
            return this.canViewPage('SUPPLIERMGMT');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canViewTcn", {
        get: function () {
            return this.canViewSection('VENDORMGMT', 'TCN');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canViewTerminalNameAbbreviations", {
        get: function () {
            return this.canViewSection('VENDORMGMT', 'ABBREVIATIONS#TERMINAL');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canViewSupplierNameAbbreviations", {
        get: function () {
            return this.canViewSection('VENDORMGMT', 'ABBREVIATIONS#SUPPLIER');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "canViewCityNameAbbreviations", {
        get: function () {
            return this.canViewSection('VENDORMGMT', 'ABBREVIATIONS#CITY');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "contractSourceType", {
        get: function () {
            return 'CONTRACT';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VendorService.prototype, "manualSourceType", {
        get: function () {
            return 'MANUAL';
        },
        enumerable: false,
        configurable: true
    });
    VendorService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], VendorService);
    return VendorService;
}(BaseManagementService));
export { VendorService };
